import { mergeClasses } from '@fluentui/react-components';
import { ChevronLeft20Filled, ChevronLeft20Regular, ChevronRight20Filled, ChevronRight20Regular, } from '@fluentui/react-icons';
import React from 'react';
import { useCarouselNavIconStyles } from './CarouselNavIcon.styles';
export var CarouselNavIcon = function (_a) {
    var isDisabled = _a.isDisabled, isFilled = _a.isFilled, isRtl = _a.isRtl, navigationDirection = _a.navigationDirection;
    var styles = useCarouselNavIconStyles();
    var className = isDisabled
        ? mergeClasses(styles.icon, styles.iconDisabled)
        : styles.icon;
    var isChevronRight = (navigationDirection === 'next' && !isRtl) ||
        (navigationDirection === 'previous' && isRtl);
    var NavigationIcon;
    if (!isFilled) {
        if (isChevronRight) {
            NavigationIcon = ChevronRight20Regular;
        }
        else {
            NavigationIcon = ChevronLeft20Regular;
        }
    }
    else {
        if (isChevronRight) {
            NavigationIcon = ChevronRight20Filled;
        }
        else {
            NavigationIcon = ChevronLeft20Filled;
        }
    }
    return React.createElement(NavigationIcon, { className: className });
};
//# sourceMappingURL=CarouselNavIcon.js.map